var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "FAQList", "data-role": "page" } },
    [
      _c(
        "div",
        { staticClass: "FAQList-content", attrs: { "data-position": "fixed" } },
        [
          _c(
            "div",
            { staticClass: "swiper-container swiperTop", attrs: { id: "Top" } },
            [
              _c(
                "swiper",
                { ref: "Top", attrs: { options: _vm.swiperTop } },
                [
                  _c(
                    "swiper-slide",
                    {
                      staticClass: "swiper-slide selected",
                      attrs: { FAQ_type: "all" }
                    },
                    [_vm._v("全部")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.FAQ_tag, function(tag, tag_ind) {
                    return _c(
                      "swiper-slide",
                      {
                        key: tag_ind,
                        staticClass: "swiper-slide",
                        attrs: { FAQ_type: tag.type_id }
                      },
                      [_vm._v(_vm._s(tag.type_name))]
                    )
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "swiper-container swiperPages",
              attrs: { id: "Pages" }
            },
            [
              _c(
                "swiper",
                {
                  ref: "Pages",
                  staticClass: "swiper-wrapper",
                  attrs: { options: _vm.swiperPages }
                },
                [
                  _c("swiper-slide", { staticClass: "swiper-slide" }, [
                    _c("div", { staticClass: "detailWrap" }, [
                      _c("div", { staticClass: "articleList" }, [
                        _c(
                          "ul",
                          _vm._l(_vm.FAQ_List, function(FAQ, FAQ_ind) {
                            return _c("li", { key: FAQ_ind }, [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.PutFAQTemp(FAQ.qa_id)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "txt-info" }, [
                                    _c("h4", { staticClass: "article_desc" }, [
                                      _vm._v(_vm._s(FAQ.qaTitle))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "bookmark-tag" },
                                      [
                                        _c("i", {
                                          class: [
                                            FAQ.is_keep
                                              ? "icon-bookmark-full active"
                                              : "icon-bookmark",
                                            "bookmarkIcon"
                                          ],
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              _vm.SetFavorites(
                                                FAQ.qa_id,
                                                FAQ.is_keep
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          })
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.FAQ_tag, function(tag, tag_ind) {
                    return _c(
                      "swiper-slide",
                      { key: tag_ind, staticClass: "swiper-slide" },
                      [
                        _c("div", { staticClass: "detailWrap" }, [
                          _c("div", { staticClass: "articleList" }, [
                            _c(
                              "ul",
                              _vm._l(_vm.FAQ_List, function(FAQ, FAQ_ind) {
                                return FAQ.qaType == tag.type_id
                                  ? _c("li", { key: FAQ_ind }, [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.PutFAQTemp(FAQ.qa_id)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "txt-info" },
                                            [
                                              _c(
                                                "h4",
                                                { staticClass: "article_desc" },
                                                [_vm._v(_vm._s(FAQ.qaTitle))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "bookmark-tag" },
                                                [
                                                  _c("i", {
                                                    class: [
                                                      FAQ.is_keep
                                                        ? "icon-bookmark-full active"
                                                        : "icon-bookmark",
                                                      "bookmarkIcon"
                                                    ],
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.SetFavorites(
                                                          FAQ.qa_id,
                                                          FAQ.is_keep
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              })
                            )
                          ])
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("favoritesToast", {
        attrs: {
          show: _vm.toastControl.show,
          full: _vm.toastControl.full,
          content: _vm.toastControl.content,
          showTime: _vm.toastControl.showTime
        },
        on: {
          close: function($event) {
            _vm.toastControl.show = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "qk-link" }, [
      _c("div", { staticClass: "qk-link-wrap-col1" }, [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://docs.google.com/forms/d/1OYreO78umtblAlL5D1Z4jFWHmjvzy_mj-qCBZPi285I/viewform?edit_requested=true",
              target: "_blank"
            }
          },
          [_c("div", [_c("span", [_vm._v("我需要幫助")])])]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "overlayBG on" }, [
      _c("div", { staticClass: "s-loading" }, [
        _c("div", { staticClass: "loader" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db6a4a18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db6a4a18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQList.vue
// module id = null
// module chunks = 